import dayjs from 'dayjs';
import {
  putMinioFile,
  postFilePresignedUrl
  // postUploadUpload
} from '@/api/common';
import { ERR_AXIOS_CANCEL_CODE } from '@/utils/error';

const contentTypeObj = {
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  mp4: 'video/mp4',
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  xls: 'aapplication/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ppt: 'application/vnd.ms-powerpoint',
  bmp: 'image/bmp',
  '3gp': 'video/3gpp',
  zip: 'application/zip',
  rar: 'application/x-rar-compressed',
  '7z': 'application/x-7z-compressed'
};
export default {
  data() {
    return {
      percentage: 0,
      isLoading: false
    };
  },

  methods: {
    putMinioFile(params) {
      return new Promise(async (resolve, reject) => {
        params = Object.assign(
          {
            file: null,
            businessName: null,
            onProgress: () => {},
            source: null
          },
          params
        );

        try {
          const { suffix, fileUrl } = this.getMinioFileFormat(
            params.file,
            params.businessName
          );

          if (!Object.keys(contentTypeObj).includes(suffix.toLowerCase())) {
            reject('当前上传文件类型未配置，请检查文件是否正确！');
            return;
          }

          // minio上传
          const res = await postFilePresignedUrl({
            path: fileUrl
          });

          const { path, queryString, baseUrl } = this.analysisUrl(res.url);

          await putMinioFile(
            baseUrl,
            path + '?' + queryString,
            params.file,
            contentTypeObj[suffix.toLowerCase()],
            params.source?.token,
            (data) => params.onProgress(data)
          );

          resolve({
            Location: res.inputUrl
          });

          // // 后端接口上传
          // let formData = new FormData();
          // formData.append('file', params.file);
          // formData.append('path', fileUrl);
          // formData.append('type', contentTypeObj[suffix.toLowerCase()]);

          // const fileData = await postUploadUpload(
          //   formData,
          //   params.source?.token,
          //   (data) => params.onProgress(data)
          // );

          // resolve({
          //   Location: fileData
          // });
        } catch (error) {
          reject(error);
        }
      });
    },

    getMinioFileFormat(file, businessName) {
      const parts = file.name.split('.');
      const fileExtension = parts[parts.length - 1];
      const today = dayjs();
      const dateString = today.format('YYYY-MM-DD');
      const timestamp = Date.now().toString();
      const randomString = Math.random().toString(36).slice(2, 10);

      return {
        fileUrl: `${businessName}/${dateString}/${timestamp}${randomString}.${fileExtension}`,
        suffix: fileExtension,
        fileName: `${timestamp}${randomString}`
      };
    },

    submitCosFile(file, businessName, source = null) {
      return new Promise(async (res, rej) => {
        try {
          const data = await this.putMinioFile({
            file,
            businessName,
            source
          });
          res({ Location: data.Location });
        } catch (error) {
          if (error?.message === ERR_AXIOS_CANCEL_CODE) {
            rej(error);
          } else {
            if (error.message != '禁止上传此类文件!') {
              this.$message.error(file.name + '，上传失败，请稍后再试');
              rej(new Error(file.name + '，上传失败，请稍后再试'));
            } else {
              rej(new Error(error.message));
            }
          }

          this.$emit('uploadError', error);
        }
      });
    },

    async submitCos(file, businessName) {
      try {
        this.isLoading = true;
        const data = await this.putMinioFile({
          file,
          businessName,
          onProgress: (res) => {
            const percentCompleted = Math.round((res.loaded * 100) / res.total);
            this.percentage = percentCompleted;

            this.$emit('uploadProgress', this.percentage);
          }
        });
        this.isLoading = false;

        this.percentage = 0;

        this.handleFileUrl({ Location: data.Location }, file);
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.percentage = 0;
        if (error?.message !== ERR_AXIOS_CANCEL_CODE) {
          if (error.message != '禁止上传此类文件!') {
            this.$message.error('上传失败，请稍后再试');
          }
        }

        this.$emit('uploadError', error);
      }
    },
    choiceImg() {
      if (this.isLoading) {
        return;
      }
      this.$refs.filElem.value = null;
      this.$refs.filElem.dispatchEvent(new MouseEvent('click'));
    },

    analysisUrl(url) {
      let arr1 = url.split('//');
      let agreement = arr1[0];
      let ip = arr1[1].substring(0, arr1[1].indexOf('/'));
      let str = arr1[1].substring(arr1[1].indexOf('/'));

      let arr2 = str.split('?');

      return {
        baseUrl: agreement + '//' + ip,
        path: arr2[0],
        queryString: arr2[1]
      };
    }
  }
};
